import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  /** Short name for the message ("agent panel"). */
  what: string;
  children: ReactNode;
}
interface State {
  error: Error | null;
}

/**
 * Keeps one broken panel from blanking the shell. The fallback names the panel, shows the
 * message, and offers a reset that remounts the children. Errors are also logged so they
 * reach the browser console for diagnosis.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error(`[cortex] ${this.props.what} crashed`, error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <div className="pane-banner crit" role="alert" style={{ margin: 10, flexDirection: 'column', alignItems: 'flex-start', gap: 6 }}>
        <strong>The {this.props.what} hit an error and was stopped.</strong>
        <code style={{ fontSize: 11, whiteSpace: 'pre-wrap' }}>{this.state.error.message}</code>
        <button className="ghost" onClick={() => this.setState({ error: null })}>Reload {this.props.what}</button>
      </div>
    );
  }
}
